const mutations = {
  addDataApi: (state, payload) => {
    state.dataAPI = payload;
  },
  removeDataApi: (state) => {
    state.dataAPI = "";
  },
  addDataAkun: (state, payload) => {
    state.dataAkun = payload;
  },

  removeNamaUser: (state) => {
    state.name = "";
  },

  addNamaUser: (state, payload) => {
    state.namaUser = payload;
  },
  addDataDashboard: (state, payload) => {
    state.dataDashboard = payload;
  },

  setDataPassword: (state, payload) => {
    state.dataPassword = payload;
  },

  dataPost: (state, payload) => {
    state.dataAfterPost = payload;
  },
};

export default mutations;
